import * as React from "react";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { Icon } from "antd";
import Report6PDFTemplate from "./Report6PDFTemplate";
import { TReport6ApplicantPresentationModel } from "../../../presenter/report/model/Report6ApplicantPresentationModel";

const Report6PDFExportLink = ({
  translate,
  applicants,
  title,
  fileName
}: {
  translate: any;
  applicants: TReport6ApplicantPresentationModel[];
  title: string;
  fileName: string;
}) => {
  return (
    <PDFDownloadLink
      document={
        <Report6PDFTemplate
          translate={translate}
          applicants={applicants}
          title={title}
        />
      }
      fileName={fileName}
    >
      {({ blob, url, loading, error }) =>
        loading ? (
          translate("reports.document.loading")
        ) : (
          <Icon
            type="file-pdf"
            theme={"outlined"}
            style={{ fontSize: 20, color: "#ED1C24" }}
          />
        )
      }
    </PDFDownloadLink>
  );
};

export default Report6PDFExportLink;
